import api from '@/lib/base-api'
import { filterEnabledModels, type EnabledAIModel } from '@/lib/ai-models'
import type { AIModelProviderResponse } from '@/types/response'
import { create } from 'zustand'

interface AIModelStore {
  models: AIModelProviderResponse[]
  enabledModels: EnabledAIModel[]
  selectedRegenerateModelId: string
  setSelectedRegenerateModel: (id: string) => void
  fetchModels: () => Promise<void>
}

export const useAiModelStore = create<AIModelStore>()((set) => ({
  models: [],
  enabledModels: [],
  selectedRegenerateModelId: '',
  setSelectedRegenerateModel: (id) => set({ selectedRegenerateModelId: id }),
  fetchModels: async () => {
    const data = await api.get<{ result: AIModelProviderResponse[] }>('/api/company/models')
    const enabled = filterEnabledModels(data.result)
    set((state) => ({
      models: data.result,
      enabledModels: enabled,
      selectedRegenerateModelId: state.selectedRegenerateModelId || (enabled[0] ? String(enabled[0].version_id) : ''),
    }))
  },
}))
